import type { BreadcrumbComponentTemplates } from '../../components/Breadcrumb/Breadcrumb';

const defaultTemplates: BreadcrumbComponentTemplates = {
  home: 'Home',
  separator: '>',
};

export default defaultTemplates;
